import { map, take } from 'rxjs/operators';
import { Component, Input, OnInit } from '@angular/core';

import { CartFunnelStoreSelector } from '@common/selectors/cart-funnel.selector';
import { CartFunnelStoreDispatcher } from '@common/dispatchers/cart-funnel.dispatcher';

@Component({
  selector: 'app-cart-funnel-checkbox-item-block',
  templateUrl: './cart-funnel-checkbox-item-block.component.html',
})
export class CartFunnelCheckboxItemBlockComponent implements OnInit {
  @Input() title!: string;
  @Input() checked = false;
  @Input() required = false;
  @Input() customTitle?: string;
  @Input() displayCustomTitleInComment = false;
  @Input() blockId!: string;
  @Input() formId!: string;

  value = this.checked;

  constructor(
    private cartFunnelSelector: CartFunnelStoreSelector,
    private cartFunnelDispatcher: CartFunnelStoreDispatcher,
  ) {}

  ngOnInit(): void {
    this.cartFunnelDispatcher.addValue({
      id: this.blockId,
      title: this.title,
      displayTitle: true,
      formId: this.formId,
      required: this.required,
      customTitle: this.customTitle,
      displayCustomTitleInComment: this.displayCustomTitleInComment,
    });

    this.cartFunnelSelector
      .selectValue(this.blockId)
      .pipe(
        take(1),
        map(form => (this.value = form?.value === true)),
      )
      .subscribe();
  }

  onValueChange(_value: string | boolean): void {
    this.cartFunnelDispatcher.updateValue({
      id: this.blockId,
      changes: {
        value: _value,
      },
    });
  }

  forceType(data: any): any {
    return data as any;
  }
}
